import React from "react";
import { StructuredText } from "react-datocms";
import styled from "styled-components";

import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const Link = dynamic(() => import("@/common/UI/Link"));

function CoursesCard(props) {
  const {
    icon,
    title,
    type,
    text,
    date,
    url,
    bgColor,
    textColor,
    showDescText,
    defaultColor,
    hoverColor,
    pressedColor,
    slug,
    labelsList,
    asLink,
    className,
    btnClass,
    titleClass,
    typeTwo,
    isSediPage,
    linkClass,
  } = props;

  const HoverBg = styled.div`
    display: inline-flex;
    justify-content: center;
    a {
      &:hover {
        background: ${hoverColor} !important;
      }
      &:active {
        background: ${pressedColor} !important;
      }
    }
  `;

  return (
    <>
      <div
        className={
          `text-center w-full p-8 flex flex-col h-full rounded-2xl ` +
          (typeTwo ? "hidden" : className)
        }
        style={{ backgroundColor: bgColor }}
      >
        <div className="flex-grow  relative">
          {icon && <ImageUI src={icon} width={25} height={25} />}

          <h3 className={`h3-web font-bold text-lightDark ` + titleClass}>
            {title}{" "}
            <span
              className={`text-[${textColor}]`}
              style={{ color: textColor }}
            >
              {type}
            </span>
          </h3>
          {date && <h6 className="h6-web text-[#666666] py-2">{date}</h6>}
          {showDescText &&
            (typeof text === "string" ? (
              <p className="p-web text-lightDark">{text}</p>
            ) : (
              <div className="text-lightDark structure-format">
                <StructuredText data={text} />
              </div>
            ))}
        </div>
        <HoverBg>
          <Link
            href={url ? url : "#!"}
            as={asLink}
            style={{
              backgroundColor: defaultColor || textColor,
            }}
            className={
              `text-white uppercase inline-block h5-web px-5 py-3 mt-5 rounded-full  btn-link btn-link ` +
              btnClass
            }
          >
            {labelsList?.more || "Scorpi"}
          </Link>
        </HoverBg>
      </div>
      {isSediPage ? (
        <div
          className={
            `text-center w-full p-4 sm:p-6 h-full rounded-2xl ` +
            (typeTwo ? "flex justify-between relative " : className)
          }
          style={{ backgroundColor: bgColor }}
        >
          <div className="flex items-center  relative">
            {icon && <ImageUI src={icon} width={25} height={25} />}

            <h3
              className={`h3-web font-bold text-lightDark ml-3 relative top-[0.5px]`}
            >
              {title}{" "}
              <span
                className={`text-[${textColor}]`}
                style={{ color: textColor }}
              >
                {type}
              </span>
            </h3>
          </div>
          <Link
            href={url ? url : "#!"}
            as={asLink}
            style={{
              color: defaultColor || textColor,
            }}
            className={
              `inline-flex items-center justify-center px-3 h5-web  rounded-full  btn-link btn-link ` +
              linkClass
            }
          >
            <iconify-icon
              icon="akar-icons:chevron-right"
              width={22}
            ></iconify-icon>
          </Link>
        </div>
      ) : null}
    </>
  );
}

export default CoursesCard;
